import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

const initialState = {
  blindWrapClass: false,
  isCookiesData: false,
};

export const blindModeSlice = createSlice({
  name: 'blindMode',
  initialState,
  reducers: {
    toggleBlindMode: (state) => {
      state.blindWrapClass = !state.blindWrapClass;
      state.isCookiesData = !state.isCookiesData;
    },
    setBlindMode: (state, { payload }) => {
      state.blindWrapClass = payload;
    },
    setCookieData: (state, { payload }) => {
      state.isCookiesData = payload;
    },
  },
});

export const { toggleBlindMode, setBlindMode } = blindModeSlice.actions;
export const getBlindMode = (store: RootState) => store.blindMode;
